import { Type1String, Type1StringType } from "./Type1String";
import { Component, Input, OnInit, Optional } from "@angular/core";
import { PagingTableComponent, TabComponent, ModalTabComponent } from "@xo/client-common";

@Component({
    selector: "spec-app-type1-string-table",
    styleUrls: ["./type1String.table.scss"],
    templateUrl: "./type1String.table.html"
})
export class Type1StringTable extends PagingTableComponent<Type1String> implements OnInit {

    @Input() title: string;

    Type1String = Type1String;


    valueListFieldSelectValues = [];

    valueListArraySelectValues = [];

    constructor(
        @Optional() modalTab: ModalTabComponent, @Optional() tab: TabComponent) {
        super(Type1StringType, Type1String.columnInfo, modalTab || tab);
        this.valueListFieldSelectValues = this.createReferenceMap(Type1String.valueListFieldKeys, Type1String.getValueListFieldValues);
        this.valueListArraySelectValues = this.createReferenceMap(Type1String.valueListArrayKeys, Type1String.getValueListArrayValues);
    }

    async ngOnInit() {
        this.refreshList();
    }

    getClasses(type1String) {
        let classes: any = { objects: true };
        return classes;
    }

    formatValueListField(valueListField) {
        return Type1String.getValueListFieldValues(valueListField);
    }

    formatValueListArray(valueListArray) {
        if (!valueListArray) {
            return "";
        }
        return valueListArray.map(Type1String.getValueListArrayValues);
    }
}
